import { FunctionComponent, useEffect, useState } from "react";
import commonStyles from "../../CommonStyles/CommonGraphStyles.module.css";
import TaskBarChartOrg from "../TaskBarChartOrg/TaskBarChartOrg";
import TaskBarTable from "../TaskBarChartOrg/TaskBarTable";
import { colour_code } from '../../Values/constants';
import { connect } from "react-redux";
import { CSVLink } from "react-csv";
import { DownloadReportCsv } from "../CommanDownloadFunction";
import { themeColors } from "../../Components/theme";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import "../../theme-vars.css";

type props = {
  analyticsData: any;
  usersList: any;
  checked: boolean;
  teamsData: any;
  history: any;
  filter: "MTD" | "YTD" | "PM" | "All" | "CUSTOM";
  source: boolean;
  passOnFilters: any;
  tasksFilters: any;
  overDueReportData: any;
  theme: any;
};

const OverdueTask: FunctionComponent<props> = ({
  analyticsData,
  usersList,
  checked,
  history,
  teamsData,
  filter,
  source,
  passOnFilters,
  tasksFilters,
  overDueReportData,
  theme
}) => {

  /** ----------------------------------------------
*  Responsive Logic (MUI Breakpoints)
* ---------------------------------------------- */
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

  /** ----------------------------------------------
*  CSV Download Data State
* ---------------------------------------------- */
  const [overDuReportData, setOverDueReportData] = useState<any>([]);
  const [overDueReportHeader, setOverDueReportHeader] = useState<any>([]);


  /** ------------------------------------------------
* Extract headers from callback reason data
* ------------------------------------------------ */
  useEffect(() => {
    let headerArray: any[] = [];
    overDueReportData?.map((list: any) => {
      return list?.type?.map((li: any) => {
        return headerArray.push(li.type);
      })
    })
    setOverDueReportHeader(headerArray)
  }, [overDueReportData]);

  /** ------------------------------------------------
* Download CSV
* ------------------------------------------------ */
  const downLoadReport = () => {
    const csvReportData = DownloadReportCsv(overDueReportData, overDueReportHeader, usersList, 'type');
    setOverDueReportData(csvReportData);
  }

  /** ------------------------------------------------
* Reusable styling for tables/cards by theme
* ------------------------------------------------ */
  const tableContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }

  /** CSS Variables */
  const fontFamilyMain = "var(--font-family-main)";
  const fontSizeMedium = "var(--font-size-medium)";
  return (
    <>
      <Box
        className={`d-flex flex-column ${isMobile ? 'mb-2' : 'mb-3'}`}
        sx={{
          width: "100%",
          padding: isMobile ? 1 : 0,
        }}
      >

        {/* -------------------------------------------------------
       * Header Section with CSV Download Icon
       * ------------------------------------------------------- */}
        <h6 className={commonStyles.heading} style={{ fontFamily: fontFamilyMain, fontSize: fontSizeMedium, margin: isMobile ? "0px 0px 10px 5px" : "0px 0px 10px 0px" }}>
          Overdue Task Summary
          <CSVLink onClick={downLoadReport} data={overDuReportData}>
            {" "}
            <svg
              style={{ cursor: "pointer", color: "rgb(39, 159, 159)" }}
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-download"
              viewBox="0 0 16 16"
            >
              <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
              <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
            </svg>
          </CSVLink>
        </h6>

        {/* -------------------------------------------------------
       * Content Area (Chart + Table)
       * ------------------------------------------------------- */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 2 : 4,
            width: "100%",
            alignItems: isMobile ? "stretch" : "flex-start",
          }}
        >
          <Box
            id="callBackBar"
            className="card p-4 shadow rounded"
            sx={{
              width: isMobile ? "100%" : "40%",
              maxHeight: 350,
              minHeight: 350,
              ...tableContainerStyles,
              mb: isMobile ? 2 : 0,
            }}
          >
            <TaskBarChartOrg
              analyticsData={analyticsData}
              type={"Overdue"}
              color={colour_code}
              style={{ width: "100%" }}
              history={history}
              filter={filter}
            />
          </Box>

          {/* ----------------------
         * Table Box
         * ---------------------- */}
          <Box
            className="card p-4 shadow rounded"
            sx={{
              width: isMobile ? "100%" : "60%",
              maxHeight: 350,
              ...tableContainerStyles,
            }}
          >
            <Box
              id="feedback"
              sx={{
                width: "100%",
                ...tableContainerStyles,
                color: "#000"
              }}
            >
              <TaskBarTable
                data={analyticsData}
                heading={"Overdue Task Summary"}
                type={"Overdue"}
                usersList={usersList}
                checked={checked}
                teamsData={teamsData}
                style={{ width: "100%" }}
                filter={filter}
                history={history}
                source={source}
                taskFilter={tasksFilters}
                leadFilter={passOnFilters}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

/**
 * Maps Redux state to component props.
 */
const mapStateToProps = (state: any) => {
  return {
    overDueReportData: state.overDueReportData.data,
    theme: state.theme.isLightMode
  };
};
export default connect(mapStateToProps)(OverdueTask);
